<ng-container *ngIf="listGroupItems && listGroupItems.length > 0">
  <h4 class="section-header">Specs</h4>
  <common-list-dropdown-group [listGroupItems]="listGroupItems"></common-list-dropdown-group>
</ng-container>
